module.exports = __webpack_public_path__ + "static/img/stewart-hamish.d41ba6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stewart-hamish.jpg
// module id = Bq0Z
// module chunks = 0